import { TypeDefinition } from "../generic";

export class MediaTypes {
    public static Image: TypeDefinition = { id: 1, name: "Image" };
    public static PDF: TypeDefinition = { id: 2, name: "PDF" };
    public static MSPowerPoint: TypeDefinition = { id: 3, name: "MS PowerPoint" };
    public static Video: TypeDefinition = { id: 4, name: "Video" };
    public static MSWord: TypeDefinition = { id: 5, name: "MS Word" };
    public static MSExcel: TypeDefinition = { id: 6, name: "MS Excel" };
    public static Placeholder: TypeDefinition = { id: 7, name: "Placeholder" };
    public static Text: TypeDefinition = { id: 8, name: "Text" };

    public static Values: TypeDefinition[] = [
        MediaTypes.Image,
        MediaTypes.PDF,
        MediaTypes.MSPowerPoint,
        MediaTypes.Video,
        MediaTypes.MSWord,
        MediaTypes.MSExcel,
        MediaTypes.Placeholder,
        MediaTypes.Text,
    ];
}



// WEBPACK FOOTER //
// ./src/models/upload/MediaTypes.ts